import newsService from '@/services/newsService';

export default {
  namespaced: true,
  state: {
    newsItems: [],
    totalItems: 0,
    nextPage: null,
    previousPage: null,
    currentItem: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_NEWS_ITEMS(state, response) {
      console.log('Setting news items in store:', response);

      // Check if the response has a paginated structure
      if (response && response.results) {
        state.newsItems = response.results;
        state.totalItems = response.count;
        state.nextPage = response.next;
        state.previousPage = response.previous;
        console.log('Extracted news items from paginated response:', state.newsItems);
      } else if (Array.isArray(response)) {
        // Handle the case where the response is a direct array
        state.newsItems = response;
        console.log('Extracted news items from array response:', state.newsItems);
      } else {
        console.error('Unexpected news response format:', response);
        state.newsItems = [];
      }
    },
    SET_CURRENT_ITEM(state, item) {
      console.log('Setting current news item in store:', item);
      state.currentItem = item;
    },
    SET_LOADING(state, status) {
      console.log('Setting news loading state:', status);
      state.loading = status;
    },
    SET_ERROR(state, error) {
      console.error('Setting news error state:', error);
      state.error = error;
    }
  },
  actions: {
    fetchNewsItems({ commit }, params = {}) {
      console.log('Fetching news items...');
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return newsService.getNewsItems(params)
        .then(response => {
          console.log('News items API response:', response);
          commit('SET_NEWS_ITEMS', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          console.error('Error fetching news items:', error);
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    fetchNewsItem({ commit }, slug) {
      console.log(`Fetching news item with slug: ${slug}`);
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return newsService.getNewsItem(slug)
        .then(response => {
          console.log('News item API response:', response);
          commit('SET_CURRENT_ITEM', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          console.error(`Error fetching news item with slug ${slug}:`, error);
          console.error('Error response:', error.response);
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    }
  }
};